<template>
  <!-- Google кнопка -->
    <a
      class="social-link"
      href="https://auth2.multiplex.ua/aplogin"
    >
      <RoundAppleIcon />
    </a>
  <!-- Google кнопка -->
</template>

<script>
  export default {
    name: 'AppleBtn'
  }
</script>


// WEBPACK FOOTER //
// AppleBtn.vue?11f6859c